/** Langues de l'interface AGORA. Toute clé du dictionnaire doit exister dans chacune (npm run i18n:check). */
export const LANGUES = ['fr', 'en', 'de', 'it', 'es', 'pt'] as const;
export type Langue = (typeof LANGUES)[number];

export const LANGUE_PAR_DEFAUT: Langue = 'fr';

/**
 * Langues des documents envoyés aux tiers (offres, correspondance d'un contact) : celles de l'interface + le polonais
 * (décision D6 du 23/10/2026, docs/COMMERCE-CADRAGE.md). L'interface reste dans les 6 langues ci-dessus.
 */
export const LANGUES_DOCUMENT = [...LANGUES, 'pl'] as const;
export type LangueDocument = (typeof LANGUES_DOCUMENT)[number];

/** Locale utilisée pour les formats (Intl) quand l'interface est dans cette langue. */
export const LOCALE_DE_LANGUE: Record<Langue, string> = {
  fr: 'fr-FR',
  en: 'en-GB',
  de: 'de-DE',
  it: 'it-IT',
  es: 'es-ES',
  pt: 'pt-BR',
};

export function estLangue(v: unknown): v is Langue {
  return typeof v === 'string' && (LANGUES as readonly string[]).includes(v);
}
